import React, { useEffect, useState } from "react";

const SimpleThreeDotsLoader = ({ message }) => {
  // Predefined cycling messages (kept separate from the prop)
  const MESSAGES = [
    "Thinking",
    "Analyzing",
    "Gathering information",
    "Processing",
    "Preparing data",
    "Fetching details",
  ];

  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (!message) {
      // Only cycle if no message is provided
      const id = setInterval(() => {
        setMsgIndex((i) => (i + 1) % MESSAGES.length);
      }, 2000); // 2 seconds
      return () => clearInterval(id);
    }
  }, [message]);

  return (
    <div className="flex justify-start">
      <div className="py-2 self-start">
        <div className="flex flex-col items-center">
          <div className="flex justify-center space-x-2 mb-1">
            <div
              className="bg-indigo-500 rounded-full animate-pulse-grow"
              style={{
                animationDelay: "0ms",
                animationDuration: "1.2s",
                width: "12px",
                height: "12px",
              }}
            />
            <div
              className="bg-indigo-500 rounded-full animate-pulse-grow"
              style={{
                animationDelay: "400ms",
                animationDuration: "1.2s",
                width: "12px",
                height: "12px",
              }}
            />
            <div
              className="bg-indigo-500 rounded-full animate-pulse-grow"
              style={{
                animationDelay: "800ms",
                animationDuration: "1.2s",
                width: "12px",
                height: "12px",
              }}
            />
          </div>
          <div
            className="text-sm text-gray-600 italic text-center"
            aria-live="polite"
          >
            {message ? message : MESSAGES[msgIndex]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleThreeDotsLoader;
